export default __webpack_public_path__ + "static/media/cctv-gray.f1e775c5.png";